import App from '../team-members/tem-member-form';
import '../index.css';
import Layout from '../layout';

export const TeamPage = () => {
  return (
    <Layout>
      <App />
    </Layout>
  );
}